export default __webpack_public_path__ + "static/rsz_dlastudentapl-logo-e52f963d1d2b64d30036b0f65f8916aa.jpg";